<template>
  <div class="container container-ex border rounded mt-1 p-1 bg-grad-grey">
    <div class="row">
      <AuctioneerMenu v-if="store.user_type == 'auctioneer'"></AuctioneerMenu>
      <div class="col">
        <i class="bi bi-power text-danger float-end" @click="logout()"></i>
      </div>
    </div>
    <AuctioneerHome v-if="store.user_type == 'auctioneer'"></AuctioneerHome>
    <BidderHome v-if="store.user_type == 'bidder'"></BidderHome>
    <ViewerHome v-if="store.user_type == 'viewer'"></ViewerHome>
    <AuctionList v-if="!store.user_type"></AuctionList>
  </div>
</template>

<script setup>
import { useStore } from "../store/index";
import AuctioneerMenu from "@/components/menu/AuctioneerMenu.vue";
import AuctioneerHome from "@/components/home/AuctioneerHome.vue";
import BidderHome from "@/components/home/BidderHome.vue";
import ViewerHome from "@/components/home/ViewerHome.vue";
import AuctionList from "@/components/setusertype/AuctionList.vue";
import { useRouter } from "vue-router";
import { watchEffect } from "vue";
import supabase from "@/supabase/config";
const router = useRouter();
const store = useStore();
const logout = async () => {
  const { error } = await supabase.auth.signOut();
  store.clearData();
  router.push("/");
};
watchEffect(() => {
  if (!store.user.id) {
    logout();
  }
});
</script>
<style scoped>
.container-ex {
  /* max-width: calc(100% - 40px); 
  margin-left: 20px;
  margin-right: 20px; */
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}
</style>
